import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 框架
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 播放器
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

// 使用md5加密
import md5 from 'js-md5'
Vue.prototype.$md5 = md5;

// 使用cookie
import cookie from 'vue-cookie'
Vue.prototype.$cookie = cookie;

import 'lib-flexible'

Vue.use(VideoPlayer)

// 使用base64进行加密
let Base64 = require('js-base64').Base64

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  Base64,
  render: h => h(App)
}).$mount('#app')
